import React from 'react';
import { Button } from '../ui/button';
import DraftStatusBadge from '../DraftStatusBadge';

const SOHeader = ({ editSO, onCancel, draftStatus, onManualSave }) => (
  <div className="flex items-start justify-between">
    <div>
      <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: 'Nunito' }}>
        {editSO ? `Edit ${editSO.so_number}` : 'Create Sales Order'}
      </h1>
      <div className="flex items-center gap-3">
        <p className="text-gray-500 text-sm">Invoice-style order creation</p>
        {!editSO && <DraftStatusBadge status={draftStatus} onManualSave={onManualSave} />}
      </div>
    </div>
    {onCancel && (
      <Button variant="outline" size="sm" onClick={onCancel} className="text-red-600 border-red-200 hover:bg-red-50" data-testid="so-cancel-top">Cancel</Button>
    )}
  </div>
);

export default SOHeader;
